module.exports = __webpack_public_path__ + "img/viewfdbck.e0c09f70.svg";